<template>
  <div class="challenge-container">
		<div class="challenge-header outbox">
			<div class="title">{{ challengeData.tasp_title }} {{ formatTime(challengeData.tasp_start_time*1000,'YYYY.MM.DD') }}</div>
			<div class="info-line">
				<span class="view-count">
					<i class="el-icon-view"></i>
					{{ challengeData.tasp_hits }} 
				</span>
				<span class="publish-time">{{ $t('发表于') }}  {{ challengeData.update_time }}</span>
			</div>
      <div class="introduction" v-html="challengeData.tasp_content"></div>
		</div>

    <div class="challenge-content outbox" v-if="!complete">
      
			<!-- 题目 -->
      <div class="challenge-questions">
        <div class="section-title">{{ $t('题目') }}</div>
        <template v-for="(question, qIndex) in questions" 
          @key="question.taspq_id">
          <QuestionItem 
            :question="question"
            :index="qIndex"
            :taspq_id="question.taspq_id"
            :taspq_type="question.taspq_type"
            :value="userAnswers[qIndex]"
            @select="handleOptionClick"
            @multiSelect="toggleMultiOption"
            @update:text="updateTextAnswer"
            @update:score="updateScoreAnswer"
          />
          
        </template>
      </div>
      
      <div class="action-bar">
        <el-button type="text" class="submit-btn" v-throttle="2000" @click="submitAnswers">{{ $t('提交答案') }}</el-button>
      </div>
    </div>

			<!-- 答题完成 -->
			<Result typeNum="1" :ta_id="ta_id" :tas_id="tas_id" :tasp_id="tasp_id" v-if="complete"></Result>

  </div>
</template>

<script>
import Result from './components/result.vue';
import QuestionItem from './components/QuestionItem.vue';
import { taskDetailList,taskSubmit } from '@/api/challenge';

export default {
  name: 'DailyChallenge',
  components: {
    Result,
    QuestionItem
  },
  data() {
    return {
			complete: false,
      challengeData: {
        tasp_title: '',
        update_by: '',
        tasp_hits: 0,
        publishTime: '',
        tasp_describe: '',
      },
      questions: [],
      userAnswers: [{}],
    };
  },
  computed: {
    ta_id() {
      return this.$route.params.ta_id; // 获取路由参数 活动id
    },
    tas_id() {
      return this.$route.params.tas_id; // 获取路由参数 阶段id
    },
    tasp_id() {
      return this.$route.params.tasp_id; // 获取路由参数 试卷id
    },
  },
	mounted(){
    this.getData();
	},
  methods: {
    // 初始化获取数据
    async getData() {
      const res = await taskDetailList({ 
        ta_id: this.ta_id,//358
        tas_id: this.tas_id,//1
        tasp_id: this.tasp_id //15
      });
      if (res.status == 200) {
        if(res.data.status == false){
          this.$message.error(res.data.msg);
          return;
        }
        this.challengeData = res.data.paper;
        if(res.data.paper.is_submit == 10){
          this.complete = true;
          return;
        }
        this.questions = res.data.question.map(item=>{
          if(item.taspq_type == 30){
            item.taspq_options = item.taspq_options.map(option=>{
              return {
                ...option,
                score_min: parseInt(option.score_min),
                score_max: parseInt(option.score_max),
              }
            });
          }
          return item;
        });
        this.initUserAnswers();
      }
    },
    // 初始化用户答案
		initUserAnswers() {
      this.userAnswers = this.questions.map(item => {
        let obj;
        if(item.taspq_type==10) return {
          taspq_id:item.taspq_id,
          option_title:'',
          value: ''
        };
        if(item.taspq_type == 20) return [];
        if(item.taspq_type == 30) return item.taspq_options.map(option=>{
          return {
            taspq_id:item.taspq_id,
            title:0,
            value:0
          }
        });  
        if(item.taspq_type == 40) return {
          taspq_id:item.taspq_id,
          title:'',
          value:''
        };
      });
    },
    //单选题选择
		handleOptionClick(qIndex, oIndex, option){
      let value = this.userAnswers[qIndex];
      value.option_title = option.title;
      value.value = oIndex;
			this.$set(this.userAnswers, qIndex, value);
		},
    // 多选题选择
		toggleMultiOption(qIndex, oIndex, option,taspq_id) {
      let value = this.userAnswers[qIndex];

      //判断value数组内的value字段是否和oIndex相同
      let isExist = value.some(item => item.value == oIndex);
      if(!isExist){
        value.push({
          taspq_id:taspq_id,
          option_title:option.title,
          value:oIndex
        });
      }else{
        value.map((item,index) => {
          if(item.value==oIndex){
            value.splice(index, 1);
          }
        })
      }
      this.$set(this.userAnswers, qIndex, value);
		},
    // 文本题更新
    updateTextAnswer(index, text) {
      let value = this.userAnswers[index];
      value.title = value.value = text;
      this.$set(this.userAnswers, index, value);
    },
    // 评分题选择
    updateScoreAnswer(index, oIndex, score) {
      let value = this.userAnswers[index];
      value[oIndex].title = value[oIndex].value = score;
      this.$set(this.userAnswers, index, value);
    },
    // 提交答案
    async submitAnswers() {
      let subObj = {
        ta_id: this.challengeData.ta_id,
        tas_id: this.challengeData.tas_id,
        tasp_id: this.challengeData.tasp_id,
        dd_question_type: this.challengeData.dd_question_type,
        data: JSON.parse(JSON.stringify(this.userAnswers))
      }
      // 验证是否所有必填题目都已作答 
      let isAllAnswer = true;
      subObj.data.forEach((item,index)=>{
        if(Array.isArray(item)){
          item.forEach(item2=>{
            if((!item2.title && !item2.option_title) && this.questions[index].taspq_require==10){
              isAllAnswer = false;
            }
          });
          if(item.length==0 && this.questions[index].taspq_require==10){
            isAllAnswer = false;
          }
          if(item.length==0 && this.questions[index].taspq_require!=10){
            item.push({
              taspq_id:this.questions[index].taspq_id,
              title:"",
              value:""
            })
          }
        }else{
          if((!item.title && !item.option_title) && this.questions[index].taspq_require==10){
            isAllAnswer = false;
          }
        }
      });
      
      if (!isAllAnswer) {
        this.$message.error(this.$t('请回答完必填题目再提交哦'));
        return;
      }
      
      const loading = this.$loading({
        lock: false,
        text: this.$t('加载中'),
        background: 'rgba(0, 0, 0, 0.1)'
      });
      const res = await taskSubmit(subObj);
      loading.close();
      if(res.status == 200){
        this.$message.success(this.$t('答题成功'));
          this.complete = true;
          this.initUserAnswers();
          //页面滚动到顶部
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }else{
        // this.$message.error(this.$t('提交失败'));
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.outbox{
  min-width: 1200px;
  max-width: 1680px;
  margin: 0 auto 16px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 32px;
	&:last-child{
		margin-bottom: 0;
	}
}
.challenge-container {
  width: 100%;
  padding: 80px 120px 20px;
  background: #f9f9f9;
  min-height: 100vh;
  color: #191919;
  .challenge-header {
    .title {
      font-size: 26px;
			line-height: 30px;
      margin-bottom: 16px;
    }
    
    .info-line {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin-bottom: 15px;
      height: 22px;
			line-height: 22px;
      .username {
        margin-right: 20px;
      }
      
      .view-count {
        display: flex;
        align-items: center;
        margin-right: 20px;
        
        i {
          margin-right: 3px;
        }
      }
      
      .publish-time {
        color: #777777;
      }
    }
    
    .introduction {
      font-size: 14px;
      line-height: 24px;
			font-weight: 300;
      color: #595959;
    }
  }
  .challenge-content {
    padding-bottom: 0;
  }
  
  .challenge-questions {
    .section-title {
      font-size: 24px;
			line-height: 30px;
      margin-bottom: 24px;
    }
    
    .question-item {
      margin-bottom: 16px;
			&:last-child{
				margin-bottom: 0;
			}
      .question-title {
        margin-bottom: 12px;
				line-height: 32px;
        display: flex;
        .left{
					font-weight: 700;
				}
				.question-type{
					border-radius: 4px;
					margin-top: 4px;
					padding: 0 8px;
					height: 24px;
					line-height: 24px;
					font-size: 12px;
					background-color: #F5F6F8;
					margin-left: 10px;
				}
        .required {
          color: #e0242b;
          margin-left: 5px;
        }
      }
      
      .options-list {
        .option-item {
          margin-bottom: 12px;
					line-height: 22px;
          display: flex;
          align-items: flex-start;
					cursor: pointer;
					user-select: none;
					&:last-child{
						margin-bottom: 0;
					}
					.selbtn{
						margin: 5px 10px 0 0;
						width: 12px;
						height: 12px;
						border-radius: 50%;	
						border: 1px solid #b3b3b3;
						&.ckd{
							border: 4px solid #2673E5;
						}
					}
					.selbtn2{
						margin: 5px 10px 0 0;
						width: 12px;
						height: 12px;
						font-size: 10px;
						text-align: center;
						line-height: 10px;
						border-radius: 3px;	
						border: 1px solid #b3b3b3;
						&.ckd{
							border-color:  #2673E5;
							background: #2673E5;
							color: #fff;
						}
					}
            
					.option-text {
						font-size: 14px;
					}
        }
        ::v-deep .el-textarea {
          width: 100%;
          .el-textarea__inner {
            width: 100%;
            line-height: 22px;
          }
          .el-input__count {
            right: 10px;
            bottom: 2px;
            font-size: 12px;
            color: #808080;
            background: transparent;
            line-height: 20px;
            height: 20px;
          }
        }

      }


    }
  }
  
  .action-bar {
    text-align: center;
    padding: 24px 0 32px;
		margin: 32px 0 0;
    border-top: 1px dashed rgb(230, 230, 230);
    .submit-btn {
			box-sizing: border-box;
      font-size: 14px;
			border: 1px solid rgb(179, 0, 0);
			border-radius: 20px;
      padding: 12px;
			min-width: 86px;
			background: rgb(255, 255, 255);
      color: #B30000;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background-color: rgba(179, 0, 0, 0.1);
      }
    }
  }
}
</style>